/* eslint-disable */
import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  ChartDataLabels
);

const RevenueBarChart = ({ data = [] }) => {
  const values = data.map((d) => Number(d.value || 0));
  const labels = data.map((d) => d.label);
  const minVal = Math.min(...values, 0);
  const maxVal = Math.max(...values, 100);

  const chartData = {
    labels,
    datasets: [
      {
        label: 'Revenue',
        data: values,
        // backgroundColor: ['#2196F3', '#FFC107', '#00BCD4'],
        backgroundColor: (ctx) => {
          const value = ctx.raw;
          return value < 0 ? "red" : ['#2196F3', '#FFC107', '#00BCD4'];
        },
        borderRadius: 2,
        barPercentage: 0.8,
        categoryPercentage: 0.5,
        barThickness: 30,
        // optional: give bars a clickable thickness even when value=0
        // barThickness: 24,
        // maxBarThickness: 30,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: 'index',
      intersect: false,
    },
    layout: {
      padding: {
        top: 20,
      },
    },
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: true,
        callbacks: {
          label: (ctx) => {
            const val = ctx.parsed?.y ?? ctx.raw;
            return `${val} Lac`;
          },
        },
      },
      datalabels: {
        color: "black",
        textStrokeColor: "white",
        textStrokeWidth: 4,
        anchor: "end",
        align: "end",
        // rotation: 90, 
        // display: "auto",
        // clip: "auto",
        font: {
          weight: "bold",
          size: 10,
        },
        // formatter: (value) => `${value} Lac`,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        // min: Math.min(0, minVal),
        // max: maxVal,
        ticks: {
          display: true,
          font: {
            size: 8,
            // weight: 'bold',
          },
        },
        grid: {
          display: true,
        },
        border: {
          display: true,
        },
      },
      x: {
        ticks: {
          display: true,
          font: {
            size: 8,
            // weight: 'bold',
          },
        },
      },
    },
  };

  return (
    <div style={{ width: '100%', height: '150px' }}>
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default RevenueBarChart;
